// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ct-a";
export var fulfillmentFormRail = "_ct-9";
export var headerTitleRow = "_ct-c";
export var orderDetailsWrapper = "_ct-7";
export var orderLinkTrigger = "_ct-2";
export var paymentInformationGrid = "_ct-h";
export var paymentSummaryColumn = "_ct-i";
export var shipmentContainer = "_ct-b";
export var shipmentDetailsMainPane = "_ct-8";
export var shipmentNavigationCard = "_ct-5";
export var shipmentNavigationRail = "_ct-3";
export var shipmentNavigationRailHeader = "_ct-4";
export var shipmentSummaryFact = "_ct-e";
export var shipmentSummaryGrid = "_ct-d";
export var shipmentSummaryMetadataRow = "_ct-f";
export var shipmentSummaryTags = "_ct-g";
export var shipmentWorkspace = "_ct-0";
export var shipmentWorkspaceContent = "_ct-6";
export var shipmentWorkspaceHeader = "_ct-1";